import { useInvoicesPayersListQuery } from '@bambi/api-client/bambi';
import type { SelectOption } from '@bambi/component-library/src/components/inputs/Select/SelectOption/SelectOption';
import { useMemo } from 'react';

import { isSelfPay } from '../../isSelfPay';

export function usePaymentPayers(invoiceId?: string) {
  const {
    isLoading: isLoadingPayers,
    isFetching: isFetchingPayers,
    data: payers,
  } = useInvoicesPayersListQuery(
    {
      id: invoiceId!,
    },
    {
      skip: !invoiceId,
    }
  );

  const payerOptions: SelectOption<string>[] = useMemo(() => {
    if (isLoadingPayers || isFetchingPayers || !payers) {
      return [];
    }

    return payers.reduce((acc, item) => {
      return [
        ...acc,
        {
          label: item.payer_display_name ?? 'Unknown Payer',
          value: item.id,
        },
      ];
    }, [] as SelectOption<string>[]);
  }, [isLoadingPayers, isFetchingPayers, payers]);

  const selfPayer = useMemo(() => {
    return payerOptions.find((payer) => isSelfPay(payer.label));
  }, [payerOptions]);

  return {
    isLoadingPayers: isLoadingPayers || isFetchingPayers,
    payerOptions,
    selfPayer,
  };
}
